import axios, { AxiosError, AxiosInstance, AxiosRequestConfig } from "axios";

import { BASE_URL, getClientDomain } from "@/configs";
import { getDeviceId } from "@/lib/deviceId";

// Odds and events come through our backend, which holds the sportsbook key; the browser has none.
const sportAxiosInstance: AxiosInstance = axios.create({
  baseURL: `${BASE_URL}/api/sport/feed/`,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json",
  },
});

sportAxiosInstance.interceptors.request.use(
  (config) => {
    config.headers["x-domain"] = getClientDomain();
    config.headers["x-device-id"] = getDeviceId();

    return config;
  },
  (error) => Promise.reject(error),
);

interface ApiRequest extends AxiosRequestConfig {
  errorMessage: string;
}

const sportApiRequest = async <T>(config: ApiRequest): Promise<T> => {
  try {
    const response = await sportAxiosInstance(config);

    return response.data;
  } catch (error) {
    const message =
      error instanceof AxiosError
        ? error.response?.data?.message
        : error instanceof Error
          ? error.message
          : "An unknown error occurred";
    throw new Error(message || config.errorMessage);
  }
};

export default sportApiRequest;
